import React from 'react';

import { SkeletonBlock, SkeletonOverlay, SKELETON_TOKENS } from 'components/shared';

interface ZoneSkeletonProps {
    isLoading: boolean;
}

const row: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 11 };
const grow: React.CSSProperties = { flexGrow: 1 };

export function OrdersListSkeleton({ isLoading }: ZoneSkeletonProps) {
    return (
        <SkeletonOverlay isLoading={isLoading} style={{ padding: 16, gap: 8 }}>
            <SkeletonBlock height={40} style={{ margin: '15px 0' }} />
            <SkeletonBlock height={32} />
            <SkeletonBlock height={88} />
            <SkeletonBlock height={88} />
            <div style={grow} />
            <SkeletonBlock height={40} />
        </SkeletonOverlay>
    );
}

export function OrderHeaderSkeleton({ isLoading }: ZoneSkeletonProps) {
    return (
        <SkeletonOverlay
            isLoading={isLoading}
            style={{ padding: '0 24px', justifyContent: 'center' }}
        >
            <div style={row}>
                <SkeletonBlock height={52} width={100} />
                <SkeletonBlock height={52} style={{ flexShrink: 1 }} />
                <SkeletonBlock height={52} width={144} />
                <SkeletonBlock height={52} width={144} />
                <SkeletonBlock height={52} width={132} />
            </div>
        </SkeletonOverlay>
    );
}

export function OrderItemsSkeleton({ isLoading }: ZoneSkeletonProps) {
    return (
        <SkeletonOverlay isLoading={isLoading} style={{ padding: '18px 24px 13px', gap: 8 }}>
            <SkeletonBlock height={24} />
            <SkeletonBlock height={16} width={140} style={{ marginTop: 16 }} />
            <SkeletonBlock height={88} />
            <div style={grow} />
            <SkeletonBlock height={16} width={140} style={{ alignSelf: 'flex-end' }} />
            <SkeletonBlock height={52} />
        </SkeletonOverlay>
    );
}

export function OrderSidePanelSkeleton({ isLoading }: ZoneSkeletonProps) {
    return (
        <SkeletonOverlay
            isLoading={isLoading}
            background={SKELETON_TOKENS.sidePanel}
            style={{ padding: '20px 24px', gap: 8 }}
        >
            {[40, 40, 136].map((fieldHeight, i) => (
                <React.Fragment key={i}>
                    <SkeletonBlock height={16} width={140} style={{ marginTop: i ? 12 : 0 }} />
                    <SkeletonBlock height={fieldHeight} />
                </React.Fragment>
            ))}
            <SkeletonBlock height={16} width={140} style={{ marginTop: 12 }} />
            {Array.from({ length: 4 }, (_, i) => (
                <SkeletonBlock key={i} height={32} />
            ))}
        </SkeletonOverlay>
    );
}
